import { render, staticRenderFns } from "./company-types-widget.vue?vue&type=template&id=22a56812&scoped=true&"
import script from "./company-types-widget.vue?vue&type=script&lang=js&"
export * from "./company-types-widget.vue?vue&type=script&lang=js&"
import style0 from "./company-types-widget.vue?vue&type=style&index=0&id=22a56812&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a56812",
  null
  
)

export default component.exports